import React from 'react';
import { Text, useTheme } from '@fluentui/react';
import { EnvironmentOperationMode, EnvironmentFlags } from '../models/EnvironmentModels';
import { ModeConfigurationFields } from './ModeConfigurationFields';

interface OperationModesListProps {
    modes: EnvironmentOperationMode[];
    onIsEnabledChange: (modeIndex: number, value: boolean) => void;
    onPipelineChange: (modeIndex: number, value: number | null) => void;
    onRegionChange: (modeIndex: number, value: number | null) => void;
    onWorklaneChange: (modeIndex: number, value: number | null) => void;
    onFeatureFlagChange: (modeIndex: number, flagKey: keyof EnvironmentFlags, value: boolean | null) => void;
}

export const OperationModesList: React.FC<OperationModesListProps> = ({
    modes,
    onIsEnabledChange,
    onPipelineChange,
    onRegionChange,
    onWorklaneChange,
    onFeatureFlagChange,
}) => {
    const theme = useTheme();

    return (
        <>
            {modes.map((mode, index) => (
                <div
                    key={index}
                    style={{
                        padding: '16px',
                        marginBottom: '12px',
                        backgroundColor: theme.palette.white,
                        border: `1px solid ${theme.palette.neutralLight}`,
                        borderLeft: mode.isEnabled ? `4px solid ${theme.palette.themePrimary}` : `4px solid ${theme.palette.neutralTertiary}`,
                        boxShadow: theme.effects.elevation4,
                        borderRadius: '4px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '12px',
                        }}
                    >
                        <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
                            {mode.name}
                        </Text>
                    </div>

                    {/*<Text variant="small" styles={{ root: { fontWeight: 600, marginBottom: '8px', display: 'block' } }}>*/}
                    {/*    Mode Configuration:*/}
                    {/*</Text>*/}
                    <div style={{ marginBottom: '16px' }}>
                        <ModeConfigurationFields
                            isEnabled={mode.isEnabled}
                            pipeline={mode.pipeline}
                            region={mode.region}
                            worklane={mode.worklane}
                            featureFlags={mode.featureFlags}
                            onIsEnabledChange={(value) => onIsEnabledChange(index, value)}
                            onPipelineChange={(value) => onPipelineChange(index, value)}
                            onRegionChange={(value) => onRegionChange(index, value)}
                            onWorklaneChange={(value) => onWorklaneChange(index, value)}
                            onFeatureFlagChange={(flagKey, value) => onFeatureFlagChange(index, flagKey, value)}
                            readOnly={false}
                            showModeConfig={true}
                        />
                    </div>

                    {/*<Text variant="small" styles={{ root: { fontWeight: 600, marginBottom: '8px', display: 'block' } }}>*/}
                    {/*    Feature Flag Overrides:*/}
                    {/*</Text>*/}
                </div>
            ))}
        </>
    );
};
